import React, { useEffect, useState } from 'react';
import { fromStore } from '../../../selectors';
import { useDispatch, useSelector } from 'react-redux';
import { setSortingRaws } from '../../../action';
import SortButton from '../../../components/utils/SortButton';

export const TableHeader = () => {
    const [ field, setField ] = useState('id');
    const [ sort, setSort ] = useState('ASC');
    const _sort = useSelector(fromStore.sortingRawSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        if (_sort) {
            setField(_sort.field);
            setSort(_sort.type);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = (newFiled) => {
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort(newSort);
            dispatch(setSortingRaws({ field, type: newSort }));
        } else {
            setField(newFiled);
            setSort('ASC');
            dispatch(setSortingRaws({ field: newFiled, type: 'ASC' }));
        }
    }

    return (
        <thead className="kt-datatable__head">
            <tr className="kt-datatable__row">
                <th className='kt-datatable__cell good_id'><SortButton className={field === 'id' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} text='ID' onClick={() => handleClick('id')} up={field === 'id' && sort === 'ASC'}/></th>
                <th className='kt-datatable__cell good_name'><SortButton className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} text='Название' onClick={() => handleClick('name')} up={field === 'name' && sort === 'ASC'}/></th>
                <th className='kt-datatable__cell good_info'><span>Мин. остаток</span></th>
                <th className='kt-datatable__cell good_info'><span>Цена</span></th>
                <th className='kt-datatable__cell good_info'><span>Ед. измерения</span></th>
                <th style={{ textAlign: 'right' }} className='kt-datatable__cell table_action'><span>Действия</span></th>
            </tr>
        </thead>
    );
}